import { axiosV1 } from 'interceptors/axios';
import { Dispatch } from 'redux';
import { dispatchError } from 'utils/dispatchError';
import { decryptResponse } from 'utils/token';

type GetOperationParticipantsProps = {
  operationId: string;
  societyId: string;
  emailData: any;
};

export const notifyDividendToPartners =
  ({ operationId, societyId, emailData }: GetOperationParticipantsProps) =>
  async (dispatch: Dispatch) => {
    const body = { societyId, operationId, emailData };

    try {
      const { data } = await axiosV1.post('/comms/notifyDividends', body);
      const decodedData = await decryptResponse(data);

      return decodedData;
    } catch (error) {
      dispatchError(error, dispatch);
    }
  };
